export default {
    menuMiniStateChange(context,value){
        context.commit('updateMenuMiniState',{value:value.value})
    },
    menuMobileStateChange(context,value){
        context.commit('updateMenuMobileState',{value:value})
    }
}